'use client';
import React from 'react';
import Hero from './hero';
import Content from './content';
import Maincta from '../business-travellers-car-service-dallas/mainCta';
import Backforward from '../backforward';
import Tawko2 from '../../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  return (
    <div>
      <title>Luxury Car Service for the next Sports Events in Dallas</title>
      <meta
        name="description"
        content="Have a sports event you’re attending in Dallas? Look into luxury car services to arrive in style with all the comfort and convenience and fully enjoy the day."
      />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="https://www.prestigeride.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Luxury Car Service for the next Sports Events in Dallas"
      />
      <meta
        property="og:description"
        content="Have a sports event you’re attending in Dallas? Look into luxury car services to arrive in style with all the comfort and convenience and fully enjoy the day"
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta property="twitter:url" content="https://www.prestigeride.com" />
      <meta
        name="twitter:title"
        content="Luxury Car Service for the next Sports Events in Dallas"
      />
      <meta
        name="twitter:description"
        content="Have a sports event you’re attending in Dallas? Look into luxury car services to arrive in style with all the comfort and convenience and fully enjoy the day"
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/blog/car-service-sports-events-dallas"
      />

      <Navbar />
      <Hero />
      <Content />
      <Backforward />
      <Tawko2 />
      <Footer />
      {/* <Maincta /> */}
    </div>
  );
}

export default page;
